import {NUMBER, property, STRING} from '../../config/Properties.ts';

export const PORT = property<number>('port', NUMBER);
export const GROUP = property<string>('group', STRING);
